import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedin,
  faYoutube   // ✅ ADDED
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

function ContactMe() {
  return (
    <section className="contact-section my-2">

        <h1 className="headP my-2">Contact Me</h1>
        
        <div className="contact-card">

            <p className="contact-text">
                I'm always open to discussing new opportunities, collaborations,
                AI projects, or innovative product ideas.
            </p>

            <div className="social my-4">

                {/* INSTAGRAM */}
                <a href="https://www.instagram.com/anubhav.bangari/" target="_blank" rel="noreferrer" className="soc mx-4">
                    <FontAwesomeIcon icon={faInstagram} size="3x" />
                </a>

                {/* LINKEDIN */}
                <a href="https://www.linkedin.com/in/anubhav-bangari-6092bb1a3/" rel="noreferrer" target="_blank" className="soc mx-4">
                    <FontAwesomeIcon icon={faLinkedin} size="3x" />
                </a>

                {/* ✅ YOUTUBE (NEW) */}
                <a href="https://www.youtube.com/@anubhav.bangari" target="_blank" rel="noreferrer" className="soc mx-4">
                    <FontAwesomeIcon icon={faYoutube} size="3x" />
                </a>

                {/* EMAIL */}
                <a href="mailto:bangarianubhav@gmail.com" target="_blank" rel="noreferrer" className="soc mx-4">
                    <FontAwesomeIcon icon={faEnvelope} size="3x" />
                </a>
        
            </div>

        </div>
      
    </section>
  )
}

export default ContactMe